import CouponSource from "@/api/CouponSource.js";

export const couponModule = {
    state: () => ({
        error: false,
        isLoader: false,
        coupon: null,
    }),
    mutations: {
        setCoupon(state, data) {
            state.coupon = data;
        },
        setError(state, data) {
            state.error = data;
        },
        setLoader(state, value) {
            state.isLoader = value;
        },
    },
    actions: {
        async initCoupon({commit, dispatch}, value) {
            commit('setLoader', true);
            commit('setError', null);
            await  this.$API.manager.getSource(CouponSource).setCoupon({ coupon: value }).then((response) => {
                commit('setCoupon', value);
            }).catch((error) => {
                if(error?.response?.data?.error){
                    commit('setError', error?.response?.data?.error);
                }
                commit('setCoupon', null);
            }).finally(() => {
                commit('setLoader', false);
                dispatch('cart/load', null, {root: true});
            })
        },
        async removeCoupon({commit, dispatch}) {
            commit('setLoader', true);
            commit('setError', null);
            await  this.$API.manager.getSource(CouponSource).remove().then(() => {
                commit('setCoupon', null);
            }).catch(() => {
                commit('setCoupon', null);
            }).finally(() => {
                commit('setLoader', false);
                dispatch('cart/load', null, {root: true});
            })
        },
        setCoupon({commit}, value) {
            commit('setCoupon', value);
        },
    },
    namespaced: true
}
